





import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import moment from 'moment';
import { post, get } from '@/unite/api';
import Dialog from '@/components/dialog.vue';
@Component({
  components: { SearchPaginationTable, Dialog }
})
export default class CollectionRecords extends Vue {
  mounted() {}
  created() {
    // console.log(this.api.get('/admin/apply/list', this.pageData.info))
  }
  visible: boolean = false;
  pageData: any = {
    url: '/back/v1/log/sub/search',
    isSearch: true, // 是否需要搜索框
    isFirst: true,
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      number: '',
      page_index: 1,
      page_num: 10
    }, // 传后端数据
    searchData: [
      {
        type: 'input', // text框
        model: 'number', // 字段
        tip: '手机号码',
        placeholder: '请输入手机号码'
      }
    ],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '导出日志',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: false,
      border: true,
      expandShow: false,
      optionShow: false,
      tableRowClassName: function(tableData: any) {
        if (tableData.row.card_status === 3) {
          return 'success3-row';
        }
        return '';
      },
      header: [
        // {
        //   prop: 'ID',
        //   label: 'ID',
        //   width: '70'
        // },
        {
          prop: 'sub_id',
          label: '订阅ID',
          width: '100'
        },
        {
          prop: 'number',
          label: '手机号码'
        },
        {
          prop: 'sub_name',
          label: '订阅名称'
        },
        {
          prop: 'message',
          label: '内容'
        },
        {
          prop: 'ip_addr',
          label: 'ip'
        },
        {
          prop: 'Success', // 显示字段
          _prop: 'success', // 原字段
          label: '状态',
          status: {
            true: '成功',
            false: '失败'
          }
        },
        {
          prop: 'read_at',
          label: '时间',
          type: 'time'
        }
      ],
      expand: [],
      optionWidth: 100,
      option: []
    } // table
  };
  private handleClick(methods: string, row: any) {}
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
  }
}
